<template>
  <div class="contact">
    <h1 style="font-family: 'Virgula Vulgaris'">Reporte contable</h1>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-menu
                ref="menuFrom"
                v-model="menuFrom"
                :close-on-content-click="false"
                :return-value.sync="dateFrom"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateFrom"
                    label="Desde"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    outlined
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" no-title scrollable
                             :min="minFrom" :max="maxFrom"
                             @change="getDateFrom(dateFrom)">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menuFrom = false">Cancelar</v-btn>
                <v-btn text color="primary" @click="$refs.menuFrom.save(dateFrom)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="4">
            <v-menu
                ref="menuTo"
                v-model="menuTo"
                :close-on-content-click="false"
                :return-value.sync="dateTo"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dateTo"
                    label="Hasta"
                    prepend-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" no-title scrollable
                             :min="minTo" :max="maxTo"
                             @change="getDateTo(dateTo)">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menuTo = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menuTo.save(dateTo)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="4" class="justify-center">
            <v-btn icon large fab @click="filterButton">
              <v-icon color="primary">mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <div v-if="post.online">
        <v-card-title class="title-accounting">
          Detalle Culqi
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1 subtitle-table">Descripción</th>
                    <th class=""></th>
                    <th class="subtitle-1 subtitle-table">Monto</th>
                  </tr>
                  <!--<tr>
                    <th class="">Pagos en periodo</th>
                    <th>{{post.online.transactions}}</th>
                    <th>${{ post.online.total }}</th>
                  </tr>-->
                  <tr>
                    <th class="">Comisión Variable</th>
                    <th>4.2%</th>
                    <th>${{ post.online.culqi.culqi_fee }}</th>
                  </tr>
                  <tr>
                    <th class="">Comisión Fija</th>
                    <th>$0.3xTRX</th>
                    <th>${{ post.online.culqi.fixed_fee }}</th>
                  </tr>
                  <tr>
                    <th class="">IGV</th>
                    <th>18%</th>
                    <th>${{ post.online.culqi.IGV_fee }}</th>
                  </tr>
                  <tr>
                    <th class="">TOTAL A RECIBIR</th>
                    <th>(VP - CV - CF - IGV)</th>
                    <th>${{ post.online.culqi.total_received }}</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="title-accounting">
          Detalle Paypal
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1 subtitle-table">Descripción</th>
                    <th class=""></th>
                    <th class="subtitle-1 subtitle-table">Monto</th>
                  </tr>
                  <tr>
                    <th class="">Comisión Variable</th>
                    <th>5.4%</th>
                    <th>${{ post.online.paypal.variable_fee }}</th>
                  </tr>
                  <tr>
                    <th class="">Comisión Fija</th>
                    <th>$0.3xTRX</th>
                    <th>${{ post.online.paypal.fixed_fee }}</th>
                  </tr>
                  <tr>
                    <th class="">TOTAL A RECIBIR</th>
                    <th>(VP - CV - CF)</th>
                    <th>${{ post.online.paypal.total_received }}</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="title-accounting">
          Detalle Transferencias
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1 subtitle-table">Descripción</th>
                    <th class=""></th>
                    <th class="subtitle-1 subtitle-table">Monto</th>
                  </tr>
                  <tr>
                    <th class="">Pagos en periodo</th>
                    <th>{{ post.transfer.transactions }}</th>
                    <th>${{ post.transfer.total }}</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-title class="title-accounting">
          Totales
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1 subtitle-table">Descripción</th>
                    <th class="subtitle-1 subtitle-table">Monto</th>
                  </tr>
                  <tr>
                    <th class="">Ingresos Brutos</th>
                    <th>${{ post.summary.total }}</th>
                  </tr>
                  <tr>
                    <th class="">Gastos Culqi</th>
                    <th>
                      <!--${{
                        post.online.culqi.fixed_fee + post.online.culqi.IGV_fee + post.online.culqi.culqi_fee
                      }}-->
                      ${{
                        (post.online.culqi.culqi_fee + post.online.paypal.paypal_fee).toFixed(2)
                      }}
                    </th>
                  </tr>
                  <tr>
                    <th class="">INGRESOS NETOS</th>
                    <th>{{ post.summary.total_after_discounts }}</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </div>
      <div v-else>
        <v-card-title>
          Detalle Culqi
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1">Descripción</th>
                    <th class=""></th>
                    <th class="subtitle-1">Monto</th>
                  </tr>
                  <tr>
                    <th class="">Pagos en periodo</th>
                    <th>0</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">Comisión Variable</th>
                    <th>4.2%</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">Comisión Fija</th>
                    <th>$0.3xTRX</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">IGV</th>
                    <th>18%</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">TOTAL A RECIBIR</th>
                    <th>(VP - CV - CF - IGV)</th>
                    <th>$0</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-title>
          Detalle Paypal
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1">Descripción</th>
                    <th class=""></th>
                    <th class="subtitle-1">Monto</th>
                  </tr>
                  <tr>
                    <th class="">Pagos en periodo</th>
                    <th>0</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">Comisión Variable</th>
                    <th>4.2%</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">Comisión Fija</th>
                    <th>$0.3xTRX</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">IGV</th>
                    <th>18%</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">TOTAL A RECIBIR</th>
                    <th>(VP - CV - CF - IGV)</th>
                    <th>$0</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title>
          Detalle Transferencias
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1">Descripción</th>
                    <th class=""></th>
                    <th class="subtitle-1">Monto</th>
                  </tr>
                  <tr>
                    <th class="">Pagos en periodo</th>
                    <th>0</th>
                    <th>$0</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-title>
          Totales
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-simple-table>
                <template>
                  <thead>
                  <tr>
                    <th class="subtitle-1">Descripción</th>
                    <th class="subtitle-1">Monto</th>
                  </tr>
                  <tr>
                    <th class="">Ingresos Brutos</th>
                    <th>$0</th>
                  </tr>
                  <tr>
                    <th class="">Gastos Culqi</th>
                    <th>
                      $0
                    </th>
                  </tr>
                  <tr>
                    <th class="">INGRESOS NETOS</th>
                    <th>0</th>
                  </tr>
                  </thead>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";

export default {
  name: 'Contact',
  data() {
    return {
      dateFrom: new Date().toISOString().substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      menuFrom: false,
      menuTo: false,
      minFrom: '',
      maxFrom: '',
      minTo: '',
      maxTo: '',
      table: false
    }
  },
  computed: {
    ...mapState('accounting', [
      'post'
    ]),
  },
  methods: {
    ...mapActions(['loaderChange']),
    ...mapActions('accounting', [
      'fetchReport'
    ]),
    getDateFrom(day) {
      this.minTo = day
    },
    getDateTo(day) {
      this.maxFrom = day
    },
    filterButton() {
      this.loaderChange(true)

      let request = {
        datePickerFrom: this.dateFrom,
        datePickerTo: this.dateTo
      }

      this.fetchReport(request).finally(() => {
        if (this.post.length > 0) {
          this.table = true
        }
        this.loaderChange(false)
      })
    }
  },
  mounted() {

    let d = new Date()
    d.setDate(d.getDate() + 1)
    this.loaderChange(true)
   let requestDay = {
      datePickerFrom: this.dateFrom,
      datePickerTo: `${d.toISOString().substr(0, 10)}`
    }

    this.fetchReport(requestDay).finally(() => {
      this.loaderChange(false)
    })
  }
}
</script>
<style lang="scss" scoped>
.title-accounting {
  font-family: Avenir;
}

.subtitle-table {
  font-family: Avenir!important;
}

* {
  font-family: "Avenir", sans-serif;
  color: #656565;
}

.contact {
  width: 100%;
}

h1 {
  margin-bottom: 6px;
}

a {
  font-size: 17px;
  font-weight: 400;
  text-decoration: none;
  margin: 10px 0 10px 0;
  display: inline-block;
}

dl {
  margin-top: 12px;
  color: #656565;
  font-size: 14px;
  font-weight: 200;
  line-height: 1.8em;

  dt {
    font-weight: 800;
    font-size: 18px;
    margin-top: 12px;
    margin-bottom: 6px;
  }

  dd {
    font-size: 16px;
    line-height: 27px;
  }
}
</style>
